import type { ChainId } from '@cronos-app/sdk';
import type { Fraction } from 'bi-fraction';

import type { TokenOption, TokenPriceFetcher } from '../types';
import { agentTokenFetcher } from './agentFetcher';
import { agentFunTokenFetcher } from './agentFunFetcher';
import { bondingTokenFetcher } from './bondingFetcher';
import { cdcTokenFetcher } from './cdcFetcher';
import { stableTokenFetcher } from './stableFetcher';

const getFetchers = (chainId: ChainId): TokenPriceFetcher[] => [
  agentFunTokenFetcher(chainId),
  bondingTokenFetcher(chainId),
  agentTokenFetcher(chainId),
  stableTokenFetcher,
  cdcTokenFetcher,
];

export function fetchTokenPrice(
  token: TokenOption,
  chainId: ChainId,
): Promise<{
  usd_price: Fraction;
  usd_price_change_24h: Fraction;
}> {
  const fetcher = getFetchers(chainId).find((f) => f.supportsToken(token));
  if (!fetcher) {
    throw new Error(`No fetcher found`);
  }
  return fetcher.fetchPrice(token);
}
